const resources = {
  en: {
    verifyEmail: {
      success: 'Email verified successfully.',
      successDescription: 'Your account is ready. You can now sign in here on the web or open the mobile app and sign in with the same email.',
      failed: 'Verification failed.',
      failedInvalid: 'This verification link is invalid or expired. Request a new confirmation email and try again.',
      failedMissing: 'This verification link is missing required information. Request a new confirmation email and try again.',
      resent: 'Confirmation email sent.',
      actions: {
        goToLogin: 'Go to login',
        resend: 'Resend confirmation',
        backToLogin: 'Back to login',
      },
    },
  },
  uk: {
    verifyEmail: {
      success: 'Електронну адресу успішно підтверджено.',
      successDescription: 'Ваш акаунт готовий. Тепер ви можете увійти тут у вебверсії або відкрити мобільний застосунок і увійти з тією самою поштою.',
      failed: 'Не вдалося підтвердити електронну адресу.',
      failedInvalid: 'Це посилання для підтвердження недійсне або застаріле. Запросіть новий лист підтвердження й спробуйте ще раз.',
      failedMissing: 'У цьому посиланні для підтвердження бракує потрібних даних. Запросіть новий лист підтвердження й спробуйте ще раз.',
      resent: 'Лист для підтвердження надіслано.',
      actions: {
        goToLogin: 'Перейти до входу',
        resend: 'Надіслати підтвердження ще раз',
        backToLogin: 'Повернутися до входу',
      },
    },
  },
}

export default resources
